import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import { PartnerCreateDto } from "../../models/PartnerCreateDto";
import { ComboBox$ChangeEvent } from "sap/m/ComboBox";

/**
 * @namespace akademika.akamont.pages.partnerAdd
 */
export default class PartnerAdd extends BaseController {
  route = Routes.PARTNER_ADD;
  parentRoute = Routes.PARTNER_LIST;

  public async onRouteMatched() {
    await this.fetchModel("api/Partner/GetPartnerSelectData", "partnerOptions");
  }

  public async onAddPartner() {
    const requestData = this.getModelData<PartnerCreateDto>();
    await this.post("api/Partner/AddPartner", {
      body: requestData,
    });

    this.navTo(Routes.PARTNER_LIST);
  }

  public onSapIdChange(event: ComboBox$ChangeEvent) {
    const selectedPartnerItem = event.getSource().getSelectedItem();
    // The event has the parameter "itemPressed", but we don't use it here for our check,
    // because it can be "false" when user typed the whole existing SAP id instead of clicking on the item
    if (selectedPartnerItem) {
      const partnerName = selectedPartnerItem
        .getBindingContext("partnerOptions")
        ?.getProperty("name");

      this.getModel().setProperty("/name", partnerName);
    }
  }
}
